// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"63410df0a14a133407b4","678":"cef03e4e7c67589700e1","883":"97ac14897ab703d0b3b8"}[chunkId] + ".js";
};